export const pageTransition = {
    duration: 0.5,
    ease: 'easeInOut',
};

export const modalScreenTransition = {
    duration: 0.35,
    ease: 'easeInOut',
};
